
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';
    import listado from './listados/listado-ventas.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        public Abierto: boolean = false;
        public Listados: { Nombre: string; Accion: Function; }[] = [
            { Nombre: 'Listado de publicaciones', Accion: this.AbrirListado},
        ];

        public Listado: boolean = false;
        public AbrirListado() { this.Listado = !this.Listado; };


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            await this.Iniciar();
        }

        async Iniciar()
        {
        }

    }
